// extracted by mini-css-extract-plugin
export default {"modalContent":"CloseOrderModal_modalContent__JAsiI"};